import { createAction } from 'redux-actions';
import getTeamsForms from 'ui-forms-editor-automation-lib/api/getTeamsForms';
import getTeamsLeadFlows from 'ui-forms-editor-automation-lib/api/getTeamsLeadFlows';
import getTeamsRequestState from 'ui-forms-editor-automation-lib/selectors/teams/getTeamsRequestState';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
export const REQUEST_TEAMS = '@@lib/REQUEST_TEAMS';
export const RECEIVE_TEAMS = '@@lib/RECEIVE_TEAMS';
export const FAIL_GETTING_TEAMS = '@@lib/FAIL_GETTING_TEAMS';
const requestTeams = createAction(REQUEST_TEAMS);
const receiveTeams = createAction(RECEIVE_TEAMS);
const failGettingTeams = createAction(FAIL_GETTING_TEAMS);
const fetchTeams = () => (dispatch, getState) => {
  const state = getState();
  const applicationName = getApplicationName(state);
  if (!getTeamsRequestState(getState()).shouldBeRequested()) {
    return Promise.resolve();
  }
  dispatch(requestTeams());
  let apiFunctionToCall;
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      apiFunctionToCall = getTeamsLeadFlows;
      break;
    case APPLICATION_NAMES.FORMSUI:
    default:
      apiFunctionToCall = getTeamsForms;
      break;
  }
  apiFunctionToCall().then(teams => {
    dispatch(receiveTeams(teams));
  }).catch(() => {
    dispatch(failGettingTeams());
  });
  return undefined;
};
export default fetchTeams;